import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { HRService } from "../../../../config";
import { payComponentsColumns, payrollDeductionColumns } from "../../../../data/Columns/hrmanagement";
import { AllPayrollDeductionMethods, PayComponent } from "../../../../data/Queries/HRmanagement/leavemanagement";
import PayrollDeductionForm from "./PayrollDeductionForm";

const base_url = HRService.uri;

const actions = {
  entity: "Payroll Deduction",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};

function PayrollDeductionTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Payroll Deduction"
          subtitle="View all Payroll Deduction, create or update them"
          columns={payrollDeductionColumns}
          FormComponent={PayrollDeductionForm}
          query={AllPayrollDeductionMethods}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default PayrollDeductionTable;